import { CASE } from "constants";   

// Define translations for each language
const translations = {
    'en-US': {
        CV: 'Resume',
        cv: 'resume'
        // Add more translations as needed
    },
    // Add translations for other languages
};

// Translate a text to a given language
export const translate = (text, language, wordCase) => {
    const translation = translations[language];
    if (!translation) {
        return text; // Return original text if translation not found
    }

    // Split the text into words
    const words = text.split(' ');

    // Translate each word individually
    const translatedWords = words.map(word => {
        if (wordCase === CASE.LOWER_CASE) {
            return translation[word.toLowerCase()] || word;
        } else {
            return translation[word.toUpperCase()] || word;
        }});

    // Join the translated words back together
    const translatedText = translatedWords.join(' ');

    return translatedText;
};

